import { motion } from "framer-motion";
import { Radar, ShieldCheck, Timer } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const cards = [
  {
    icon: Radar,
    title: "Proactive Alerts",
    line: "We find issues before your customer asks.",
    testid: "outcome-card-alerts",
  },
  {
    icon: ShieldCheck,
    title: "Protect Revenue & Customer",
    line: "Detects the problem, resolves it early and keeps the customer happy.",
    testid: "outcome-card-revenue",
  },
  {
    icon: Timer,
    title: "Save Time & Reduce Tickets",
    line: "Focus on what needs action, not on chasing updates.",
    testid: "outcome-card-time",
  },
];

export const Outcomes = () => (
  <section
    id="outcomes"
    className="relative mx-auto max-w-6xl px-4 py-24 sm:px-6 sm:py-32 lg:px-8"
    data-testid="outcomes-section"
  >
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: EASE }}
      className="mb-12"
    >
      <p className="font-mono text-xs uppercase tracking-[0.24em] text-mint">
        01 — What you get
      </p>
      <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
        Outcomes, not another dashboard.
      </h2>
    </motion.div>

    <div className="grid gap-5 sm:gap-6 md:grid-cols-3">
      {cards.map((c, i) => (
        <motion.div
          key={c.title}
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, ease: EASE, delay: i * 0.12 }}
          whileHover={{ y: -6 }}
          data-testid={c.testid}
          className="group rounded-2xl border border-edge bg-panel/70 p-6 transition-colors duration-300 hover:border-mint/30 hover:bg-card2 sm:p-8"
        >
          <div className="mb-6 inline-flex rounded-xl bg-mint-dim p-3 text-mint transition-transform duration-300 group-hover:-translate-y-1">
            <c.icon className="h-6 w-6" strokeWidth={1.8} />
          </div>
          <h3 className="font-display text-lg font-bold tracking-tight text-slate-50 sm:text-xl">
            {c.title}
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">
            {c.line}
          </p>
        </motion.div>
      ))}
    </div>
  </section>
);
